import { ROLE_TYPES } from "../../../../helpers/roleTypes";

export const handleDisableDocumentAction = (loggedInUser) => {
  if (loggedInUser?.roles?.includes(ROLE_TYPES.LEGAL_ONBOARDING_APPROVER)) {
    return false;
  } else {
    return true;
  }
};
